export function textMeasureFromInput(input) {
  const text = input.value;
  const fontStyles = getFontStyles(input);
  return textMeasure(text, fontStyles);
}

function getFontStyles(element) {
  const styles = window.getComputedStyle(element);
  return `${styles['font-style']} ${styles['font-variant']} ${styles['font-weight']} ${styles['font-size']}/${styles['line-height']} ${styles['font-family']}`;
}

function textMeasure(text, fontStyles) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = fontStyles;
  const textMeasurement = context.measureText(text);
  canvas.remove();
  return textMeasurement;
}
